import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// BOOTSTRAP
import { Button, Container, Table } from "react-bootstrap";
import { ArrowUpSquareFill, PencilSquare } from "react-bootstrap-icons";
// STYLES
import classes from "./FeaturesList.module.css";
// API
import apiFeatures from "../../../api/features";
// UTILITIES
import handleApiErrors from "../../../utilities/handleApiErrors";
import useInfiniteScroll from "../../../utilities/useInfiniteScroll";
// COMPONENTS
import TextInput from "../../../components/TextInput/TextInput";
import Spinner from "../../../components/Spinner/Spinner";
import PaginationItem from "../../../components/PaginationItem/PaginationItem";
import PseudoTable from "../../../components/PseudoTable/PseudoTable";
import stringSimilarity from "string-similarity";
// CONTAINERS

//STATES
const states = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
};
const resultsNumber = 20;

const FeaturesList = (props) => {
  const accesToken = useSelector((state) => state.user.access);
  // INPUT
  const [inputValue, setInputValue] = useState("");
  // ARRAYS
  const [allFeatures, setAllFeatures] = useState([]);
  const [allFeaturesUntouched, setAllFeaturesUntouched] = useState([]);
  const [featuresFiltered, setFeaturesFiltered] = useState([]);
  // PAGINATION
  const [pageNumber, setPageNumber] = useState(0);
  // PROCESS STATE
  const [process, setProcess] = useState(states.LOADING);
  // INFINITE SCROLL
  const [results, setResults] = useState(20);
  const [isFetching, setIsFetching] = useInfiniteScroll(fetchMoreListItems);

  // BRING DATA FROM API
  useEffect(() => {
    apiFeatures
      .listAll(accesToken)
      .then(({ data }) => {
        const items = data.map((item) => ({
          id: item.id,
          name: item.name,
          values: item.values,
        }));

        setAllFeatures(items);
        setAllFeaturesUntouched(items);
        setProcess(states.LOADED);
      })
      .catch((e) => {
        handleApiErrors(e);
      });
  }, []);

  // * FUNCTION FOR THE SCROLL INFINITE
  function fetchMoreListItems() {
    setTimeout(() => {
      if (results + 20 > allFeatures.length) {
        setResults(allFeatures.length);
      } else {
        setResults(results + 20);
      }
      setIsFetching(false);
    }, 500);
  }
  // EDIT FEATURE
  const editFeature = (pId) => {
    props.history.push(`/feature/${pId}`);
  };

  // SPLIT ARRAYS FUNCTION
  const splitArrays = (arr, len) => {
    var chunks = [],
      i = 0,
      n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, (i += len)));
    }
    return chunks;
  };

  // * LOGIC FROM SIMILARITY ALGORITHMN
  useEffect(() => {
    const queryedItems = allFeatures.map((item) => {
      const scoredItem = {
        ...item,
        score: stringSimilarity.compareTwoStrings(
          inputValue.toLocaleLowerCase(),
          item.name.toLocaleLowerCase()
        ),
      };
      return scoredItem;
    });
    const arrayfilteredSorted = queryedItems.sort((a, b) => {
      if (a.score > b.score) {
        return -1;
      }
      if (a.score < b.score) {
        return 1;
      }
      return 0;
    });

    const exactItems = [];
    const similarItems = [];

    arrayfilteredSorted.forEach((product) => {
      if (product.name.toLocaleLowerCase().includes(inputValue)) {
        exactItems.push(product);
      } else {
        similarItems.push(product);
      }
    });
    // When there are 3 letters or more then it shows the flitered/ordered array, if not the general array
    inputValue.length > 2
      ? setAllFeatures([
          ...exactItems,
          ...similarItems.filter((item) => item.score > 0.2),
        ])
      : setAllFeatures(allFeaturesUntouched);
  }, [inputValue]);

  //  * LOGIC FOR RESPONSIVE, IF MATCH WITH THE MOBILE SCREEN THE RESULTS PER PAGE ADD 20 RESULTS AVERY TIME SCROLL TO THE END OF THE VIEWPORT
  let breakPointResponsive = window.matchMedia("(max-width: 65em)");
  let bodyContent;
  function responsiveBreakMatch(breakPointResponsive) {
    // If media query matches, the type of results change to the state
    bodyContent =
      splitArrays(
        allFeatures,
        breakPointResponsive.matches ? results : resultsNumber
      )[pageNumber] === undefined
        ? null
        : splitArrays(
            allFeatures,
            breakPointResponsive.matches ? results : resultsNumber
          )[pageNumber].map((item, index) => {
            return (
              <>
                {/* <ReactTooltip place="left" type="info" /> */}
                <PseudoTable.Row className={classes.row}>
                  <div>{item.id}</div>
                  <div>
                    <p>{item.name}</p>
                  </div>
                  <div>
                    <Button
                      variant="light"
                      onClick={() =>
                        item.values === []
                          ? props.history.push(`/featuresList`)
                          : props.history.push(`/featureValuesList/${item.id}`)
                      }
                    >
                      Ver lista de valores
                    </Button>
                  </div>
                  <div>
                    <Button
                      variant="light"
                      onClick={() => editFeature(item.id)}
                    >
                      <PencilSquare />
                    </Button>
                  </div>
                </PseudoTable.Row>
                {breakPointResponsive.matches && allFeatures.length > 20 ? (
                  results <= 20 ? null : (
                    <div className={classes.arrowContainer}>
                      <ArrowUpSquareFill
                        // data-tip="Volver al inicio"
                        className={classes.arrowUp}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      />
                    </div>
                  )
                ) : null}
              </>
            );
          });
  }
  responsiveBreakMatch(breakPointResponsive);

  return (
    <>
      {/* TITLE */}
      <Container className={classes.title}>
        <h1>Lista de características</h1>
      </Container>

      <Container className={classes.input}>
        <TextInput
          placeholder="Introduce el nombre de la característica"
          onChange={(event) => {
            setInputValue(event.target.value);
            setPageNumber(0);
          }}
          value={inputValue}
        />
      </Container>

      {/* TABLE */}
      <Container>
        {process === "LOADING" ? (
          <Spinner
            className="mt-5"
            as="svg"
            animation="border"
            size="lg"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <>
            {/* // PAGINATION */}

            {allFeatures.length >= 10 ? (
              <PaginationItem
                //Pongo el mismo array en filtrado para que no cambie la paginación ni de error
                arrayWhole={allFeatures}
                resultsNumber={resultsNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                inputValue={inputValue}
              />
            ) : null}
            {/* //END OF PAGINATION */}

            <PseudoTable.Table responsive>
              <PseudoTable.Header className={classes.header}>
                <div>ID</div>
                <div>NOMBRE</div>
                <div>LISTA DE VALORES</div>
                <div>EDITAR</div>
              </PseudoTable.Header>
              {bodyContent}
            </PseudoTable.Table>
            {/* //* SPINNER IN MOBILE WHEN LOADING MORE ITEMS */}
            {isFetching ? (
              <div className={classes.hideSpinnerDesktop}>
                <Spinner
                  as="svg"
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            ) : null}
            {/* //BOTTOM PAGINATION */}
            {allFeatures.length >= 10 ? (
              <PaginationItem
                //Pongo el mismo array en filtrado para que no cambie la paginación ni de error
                arrayWhole={allFeatures}
                resultsNumber={resultsNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                inputValue={inputValue}
              />
            ) : null}
            {/* //END OF BOTTOM PAGINATION */}
          </>
        )}
      </Container>
    </>
  );
};

export default FeaturesList;
